export const EDIT_ATTRIBUTE = 'organization/users/attributes/edit/EDIT'
export const EDIT_ATTRIBUTE_SUCCESS = `${EDIT_ATTRIBUTE}_SUCCESS`
